export default "__VITE_ASSET__DKEi3RQI__"